import { useState } from 'react';
import { uiText } from '../../i18n';

/** Пример «Было · Стало» в пустой рамке (§1.3, решение 9 — Z2): показательный снимок шторкой с ручкой посередине.
    Картинки — только из ответа сервера (`constraints.<экран>.example`), своих демо-снимков у клиента нет. */
export interface StudioUploadExampleData {
  before: string;
  after: string;
  title?: string;
  text?: string;
  /** Подписи половинок: «Было · Стало», «Фото · Объём», «Ваше фото · В сцене» */
  labels?: [string, string];
}
export function StudioUploadExample({ example }: { example: StudioUploadExampleData }) {
  const [split, setSplit] = useState(50);
  const [left, right] = example.labels ?? ['Было', 'Стало'];
  return (
    <div className="bcu-exm studio-upload-example" aria-label={`${uiText(left)} · ${uiText(right)}`} role="group">
      <img src={example.after} alt="" />
      <img src={example.before} alt="" style={{ clipPath: `inset(0 ${100 - split}% 0 0)` }} />
      <span className="studio-upload-example-labels" aria-hidden="true">
        <b>{uiText(left)}</b>
        <b>{uiText(right)}</b>
      </span>
      <input
        type="range"
        min={0}
        max={100}
        value={split}
        aria-label={uiText('Сравнить: было и стало')}
        onChange={event => setSplit(Number(event.target.value))}
        onClick={event => event.stopPropagation()}
      />
    </div>
  );
}
/** Совместимость: помощники рамки живут в studio-upload-model.ts, прежние импорты отсюда продолжают работать. */
export { uploadExample, uploadLimits } from './studio-upload-model';
